import { motion, HTMLMotionProps } from 'framer-motion';
import { FC } from 'react';
import { IconType } from 'react-icons';
import { merge } from '../../utils/utility';
import { baseInputClass, colorButtonClass } from '../CommonClasses';
import { Loader } from '../loading/Loader';

interface ButtonProps extends HTMLMotionProps<'button'> {
  primary?: boolean;
  secondary?: boolean;
  loading?: boolean;
  Icon?: IconType;
}

export const Button: FC<ButtonProps> = ({
  onClick,
  className,
  primary,
  secondary,
  Icon,
  type = 'button',
  children,
  loading,
  ...props
}) => {
  let classToUse = 'flex items-center justify-center gap-2 leading-none rounded-md py-2 px-4 whitespace-nowrap';

  if (primary || secondary) {
    classToUse = merge(classToUse, colorButtonClass(secondary));
  } else {
    classToUse = merge(classToUse, baseInputClass);
  }

  return (
    <motion.button
      whileTap={{ scaleY: 0.95, scaleX: 0.99 }}
      transition={{ type: 'spring', duration: 0.3 }}
      className={merge(classToUse, className)}
      type={type}
      {...props}
      onClick={onClick}
    >
      {loading ? (
        <Loader className="h-5 w-5 text-white"></Loader>
      ) : (
        <>
          {Icon && <Icon className="h-5 w-5" />}
          {children}
        </>
      )}
    </motion.button>
  );
};
